import { AllowChangeGrid } from '../../../../../../services/modules/product-colors-packs/product-colors-packs.types';
import { shouldDisableGridByProductColorGridFlag } from '../../../../../../utils/shouldDisableGridByProductColorGridFlag';
import { AvailabilityEnum } from '../../../../../products/ProductTypes';

export const resolveAllowChangeGrid = (allowChangeGrid?: AllowChangeGrid): AllowChangeGrid =>
  allowChangeGrid ?? AllowChangeGrid.DISALLOW;

export interface ShouldDisableCatalogListGridParams {
  isPublic: boolean;
  canEditOrders: boolean;
  canAddToOrder: boolean;
  hasOrderItem: boolean;
  hasKitOrderItem: boolean;
  hasSelectedPacks: boolean;
  availability: AvailabilityEnum;
  allowChangeImmediateGrid: AllowChangeGrid;
  allowChangePreOrderGrid: AllowChangeGrid;
}

export const shouldDisableCatalogListGrid = ({
  isPublic,
  canEditOrders,
  canAddToOrder,
  hasOrderItem,
  hasKitOrderItem,
  hasSelectedPacks,
  availability,
  allowChangeImmediateGrid,
  allowChangePreOrderGrid,
}: ShouldDisableCatalogListGridParams): boolean =>
  isPublic ||
  !canEditOrders ||
  (!canAddToOrder && !hasOrderItem) ||
  shouldDisableGridByProductColorGridFlag({
    availability,
    allowChangeImmediateGrid,
    allowChangePreOrderGrid,
  }) ||
  hasKitOrderItem ||
  hasSelectedPacks;
